import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getPlan, generatePlan } from "../api/postPlansApi";
import { Box, Paper, Typography, Stack, Button, Alert } from "@mui/material";

export default function StepReview() {
  const { planId } = useParams();
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);
  const [status, setStatus] = useState({ loading: true, error: null, generating: false });

  useEffect(() => {
    (async () => {
      try {
        const p = await getPlan(planId);
        setPlan(p);
      } catch (e) {
        setStatus(s => ({ ...s, error: e.message }));
      } finally {
        setStatus(s => ({ ...s, loading: false }));
      }
    })();
  }, [planId]);

  const goGenerate = async () => {
    setStatus(s => ({ ...s, generating: true }));
    try {
      await generatePlan(planId);
      navigate(`/piani/${planId}/timeline`);
    } catch (e) {
      setStatus(s => ({ ...s, error: e.message, generating: false }));
    }
  };

  if (status.loading) return <Box p={3}>Caricamento…</Box>;
  if (status.error) return <Box p={3}><Alert severity="error">{status.error}</Alert></Box>;

  return (
    <Box p={3}>
      <Paper>
        <Box p={2}>
          <Typography variant="h6">Review</Typography>
          {plan ? (
            <Stack spacing={1} mt={1}>
              <Typography variant="body2"><b>Nome:</b> {plan.name}</Typography>
              <Typography variant="body2"><b>Formato:</b> {plan.format}</Typography>
              <Typography variant="body2"><b>Puntate:</b> {(plan.episodes||[]).length}</Typography>
              <Typography variant="body2"><b>Ruoli definiti:</b> {(plan.roles||[]).length || "—"}</Typography>
            </Stack>
          ) : "—"}
          <Stack direction="row" spacing={2} mt={2}>
            <Button variant="outlined" onClick={() => navigate(`/piani/${planId}/editor?step=episodes`)}>Torna al Wizard</Button>
            <Button variant="contained" onClick={goGenerate} disabled={status.generating}>Genera Piano</Button>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
}
